/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext } from "react";
import { Layout, Typography, Tooltip, Button } from "antd";
import { TitleContext } from "../../contexts/TitleContext";
import { Settings } from "react-feather";
import { useTranslation } from "react-i18next";
import Modal from "../../components/modal";
import SettingsModal from "../../components/modal/settings/SettingsModal";
import useQueryParams from "../../hooks/useQueryParams";
import AddAdminForm from "../../components/form/AddAdminForm";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import "./Header.less";
import LogoutButton from "../../components/button/LogoutButton";

export default function Header2(props: any) {
  const { title } = useContext(TitleContext);
  const { lg } = useBreakpoint();
  // const { authState } = useContext(AuthContext);
  const query = useQueryParams();
  const { t } = useTranslation();
  return (
    <Layout.Header className="site-layout-header">
      <Typography.Title
        className="TitkeHeader_r"
        style={{ margin: 0 }}
        level={4}
      >
        {title}
      </Typography.Title>
      {/* <input  type="text" /> */}
      <div className="HeaderWrapper_r">
        <Tooltip placement="bottom" title="Настройки">
          <Button
            size="large"
            // data-title="Настройки"
            className="buttonHeader_r headermargin_r"
            onClick={() => query.set("settings", "open")}
            icon={<Settings />}
          ></Button>
        </Tooltip>
        <LogoutButton />
      </div>
      {/* <div className="HeaderWrapper_r">
        <div className="HeaderWrapper_56" style={{width:"60%"}}>
           {props.filterComponent
          ? [...leftButtons, ...(props.tableProps?.leftButtons || [])]
          : [...(props.tableProps?.leftButtons || [])]}
        </div>
       
        {!props.hideExport && (
          <>
            <Button
              size="large"
              className="buttonHeader_r"
              icon={<Download color="#0c2974" />}
              onClick={() =>
                props.handleActionButtonClick(props.TableActions.EXPORT)
              }
            >
              {lg && t("export")}
            </Button>
            <ExportOptionsModal
              onCancel={() => props.setExportModal(false)}
              visible={props.exportModal}
              onOk={props.handleExport}
            />
          </>
        )}
        
        {!props.hideAdd && (
          <Button
            size="large"
            className="buttonHeader_r"
            icon={<Plus color="#0c2974" />}
            onClick={() =>
              props.handleActionButtonClick(props.TableActions.ADD)
            }
          >
            {lg && t("add")}
          </Button>
        )}
        {!props.hideDelete && (
          <Popconfirm
            placement="left"
            title={t("deleteConfirmTitle")}
            okText={t("yes")}
            cancelText={t("no")}
            onConfirm={() =>
              props.handleActionButtonClick(props.TableActions.DELETE)
            }
            onCancel={() => message.warn(t("canceled"))}
          >
            <Button
              size="large"
              loading={props.cLoading}
              danger={!!props.cError}
              className="buttonHeader_r"
              icon={<Trash color="#0c2974" />}
            >
              {lg && t("delete")}
            </Button>
          </Popconfirm>
        )}
        {!props.hideImport && (
          <>
            <Button
              size="large"
              className="buttonHeader_r"
              icon={<Upload color="#0c2974" />}
              onClick={() =>
                props.handleActionButtonClick(props.TableActions.IMPORT)
              }
            >
              {lg && t("import")}
            </Button>
            {props.sampleData && (
              <UploadExcelModal
                onOk={props.handleImport}
                visible={props.importModal}
                sampleDate={proimport { Space } from 'antd';
ps.sampleData}import LogoutButton from './../../components/button/LogoutButton';
import { Settings } from 'react-feather';

                onCancel={() => props.setImportModal(false)}
              />
            )}
          </>
        )}
      </div> */}

      {/* <FactorySelect
        hasEmpty
        key="factory"
        onChange={(val: any) => query.set("factoryId", val.toString())}
        defaultValue={+query.secureGet("factoryId") || ""}
      /> */}

      {/* <Space size={lg ? 20 : 10} className="header-actions">
        {hasPermission(authState.user) && (
          <Button
            onClick={() => query.set("add-admin", "true")}
            type="text"
            shape="circle"
          >
            <UserPlus color="#0c2974" />
          </Button>
        )}
        <Button
          className="buttonHeader_r"
          // onClick={() => query.set("settings", "open")}
          type="text"
          shape="circle"
        >
          <Upload color="#0c2974" />
          <strong>Экспорт</strong>
        </Button>
        <Button
          className="buttonHeader_r"
          //  onClick={() => query.set("settings", "open")}
          type="text"
          shape="circle"
        >
          <Download color="#0c2974" />
          <strong>Импорт</strong>
        </Button>
        <Button
          className="buttonHeader_r"
          //  onClick={() => query.set("settings", "open")}
          type="text"
          shape="circle"
        >
          <Plus color="#0c2974" />
          <strong>Добавит</strong>
        </Button>
        <Button
          className="buttonHeader_r"
          //  onClick={() => query.set("settings", "open")}
          type="text"
          shape="circle"
        >
          <Trash color="#0c2974" />
          <strong>Удалит</strong>
        </Button>
        // <Button
        //   className="buttonHeader_r"
        //   onClick={() => query.set("settings", "open")}
        //   type="text"
        //   shape="circle"
        // >
        //   <Settings color="#0c2974" />
        // </Button>

        <LogoutButton />
      </Space> */}
      <Modal footer={null} matcher="settings">
        <SettingsModal />
      </Modal>
      <Modal title={t("addAdmin")} footer={null} matcher="add-admin">
        <AddAdminForm />
      </Modal>
    </Layout.Header>
  );
}
